import CompetitionCategory from 'app/models/competition/CompetitionCategory';

const groupMatches = (group, competitionId) => {
  return group.matches.filter(match => match.competition.id === competitionId);
};

const groupByCompetition = (matchesGroupedByKickoff, clubSlug) => {
  //  input matchesGroupedByKickoff: [{day: string, matches: array}, {day: string, matches: array}]
  let transformedItems = [];
  matchesGroupedByKickoff.map(group => {
    const result = {day: group.day, competitionGroup: []};
    const competitionsByDay = group.matches.map(match => match.competition).filter(elem => elem);
    if (competitionsByDay.length) {
      // Find unique competitions, not working for objects
      const compId = competitionsByDay.map(competition => competition.id);
      const uniqueId = compId.filter((ele, pos) => compId.indexOf(ele) === pos);

      uniqueId.forEach(competitionId => {
        const currentCompetition = competitionsByDay.find(competition => competition.id === competitionId);
        // specific logic for 'testspiele' to split into agegroups
        if (isTestmatchCompetition(currentCompetition.category)) {
          // check for ageGroup to split several objects
          const matches = groupMatches(group, competitionId);

          const ageGroups = matches.map(match => {
            // check for home or away team to get all ageGroup slugs
            const team = match.homeTeam.clubSlug === clubSlug ? match.homeTeam : match.awayTeam;
            return team.ageGroup.slug;
          });
          const uniqueAgeGroup = ageGroups.filter((ele, pos) => ageGroups.indexOf(ele) === pos);
          if (uniqueAgeGroup.length) {
            const matchesByAgeGroup = uniqueAgeGroup.map(ageGroup =>
              matches.filter(match => {
                // check for home or away team to get all competitionGroups
                const team = match.homeTeam.clubSlug === clubSlug ? match.homeTeam : match.awayTeam;
                return team.ageGroup.slug === ageGroup;
              })
            );

            matchesByAgeGroup.map(matches =>
              result.competitionGroup.push({
                day: group.day,
                competition: currentCompetition,
                matches,
              })
            );
          }
        } else {
          result.competitionGroup.push({
            day: group.day,
            competition: currentCompetition,
            matches: groupMatches(group, competitionId),
          });
        }
      });
    } else {
      result.competitionGroup.push({...group, competition: null});
    }
    transformedItems.push(result);
  });
  // output transformedItems: [{day: string, competitionGroups: [{competition: object, matches: array}]}]
  return transformedItems;
};

const isTestmatchCompetition = category => {
  return new CompetitionCategory(category).isTestmatch();
};

export default groupByCompetition;
